<template>
  <div>
    <Header />
    <Banner />
    <EmsHandwareProductsPage />
    <Footer />
  </div>
</template>
<script>
import Banner from '../components/Banner.vue'
import Footer from '../components/Footer.vue'
import EmsHandwareProductsPage from '../components/EmsHandwareProductsPage.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'EmsHandwareProducts',
  components: {
    Banner,
    Footer,
    EmsHandwareProductsPage,
    Header
  }
}
</script>